<template>
  <nav aria-label="Progress" class="flex mb-6 relative z-10">
    <ul class="flex gap-2 overflow-x-auto md:flex-wrap px-2 py-1 bg-white rounded-lg">
      <StepListItem
        v-for="(sec, i) in sections"
        :key="sec.id"
        :section="sec"
        :index="i"
        :isActive="i === currentIndex"
        :isCompleted="completed.includes(i)"
        :isDisabled="false"
        @select="navigate" />
    </ul>
  </nav>
</template>
<script setup lang="ts">
import { toRefs } from "vue";
import StepListItem from "@/features/progress-stepper/components/StepListItem.vue";
import type { Section } from "@/features/progress-stepper/models/Section";

const props = defineProps<{ sections: Section[]; currentIndex: number; completed: number[] }>();
const { sections, currentIndex, completed } = toRefs(props);
const emit = defineEmits<{ (e: "navigate", idx: number): void }>();

function navigate(idx: number) {
  emit("navigate", idx);
}
</script>
